import { EventEmitter } from 'events';

export type HistoryState = any;

// Double linked list
export interface HistoryEntry<TState, TMeta> {
  hash: string;
  index: number;
  state: TState;
  meta?: TMeta;
  next: HistoryEntry<TState, TMeta> | null;
  prev: HistoryEntry<TState, TMeta> | null;
}

export interface HistoryEntryJSON<TState, TMeta> {
  state: TState;
  meta?: TMeta;
}

export interface HistoryGoToFunction {
  (steps: number): void;
  (hash: string): void;
}

export interface HistoryJSON<TState, TMeta> {
  head: string;
  entries: HistoryEntryJSON<TState, TMeta>[];
  signature: string;
}

export interface HistoryOptions<TState> {
  /**
   * WIF key for signing history
   */
  wif?: string;
  /**
   * Remove consecutive duplicate states from history
   */
  dedupe?: boolean;
  /**
   * Function to compare two states
   */
  equalityFn?: (a: TState, b: TState) => boolean;
}

export interface History<TState, TMeta> extends EventEmitter<HistoryEvents> {
  head: HistoryEntry<TState, TMeta>;
  signature: string;
  hasNextStep: boolean;
  hasPreviousStep: boolean;
  index: number;
  size: number;
  push(state: TState, meta?: TMeta): this;
  verify(signature: string): boolean;
  go(hash: string): this;
  go(steps: number): this;
  go(steps: number | string): this;
  undo(): this;
  redo(): this;
  subscribe(fn: () => void): () => void;
  reset(initialState: TState, meta?: TMeta): this;
  toJSON(): HistoryJSON<TState, TMeta>;
  toArray(flags?: HistoryArrayFlags): HistoryEntry<TState, TMeta>[];
  fromJSON(json: any): this;
}

export type HistoryEvents = {
  change: [];
};

export enum HistoryArrayFlags {
  Left = 0b01,
  Right = 0b10,
  All = 0b11,
}
